import React from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'
export const CheckMarkOutOfCircleIcon = ({ size = 24, ...props }) => {
  const { colors } = useTheme()
  return (
    <Svg width={size} height={size} fill='none' {...props}>
      <Path
        stroke={colors.iconActive}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        d='M22 11.086v.92a10 10 0 1 1-5.93-9.14'
      />
      <Path
        stroke={colors.iconActive}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        d='m22 4.005-10 10.01-3-3'
      />
    </Svg>
  )
}
